import { render, staticRenderFns } from "./shiftManagementMain.vue?vue&type=template&id=36e312fe"
import script from "./shiftManagementMain.vue?vue&type=script&lang=js"
export * from "./shiftManagementMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports